var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffres(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2684 3.58341H15.8758V2.09865C15.8742 1.54255 15.6555 1.00969 15.2674 0.616471C14.8793 0.223248 14.3534 0.0016196 13.8046 0H6.4365C5.88768 0.0016196 5.3618 0.223248 4.97373 0.616471C4.58565 1.00969 4.36692 1.54255 4.36532 2.09865V3.58341H2.97358C2.30684 3.58526 1.66794 3.85445 1.19649 4.33216C0.725031 4.80987 0.459347 5.45725 0.45752 6.13283V14.6301C0.459347 15.3056 0.725031 15.953 1.19649 16.4307C1.66794 16.9084 2.30684 17.1776 2.97358 17.1795H17.2684C17.9351 17.1776 18.574 16.9084 19.0455 16.4307C19.5169 15.953 19.7826 15.3056 19.7844 14.6301V6.13283C19.7826 5.45725 19.5169 4.80987 19.0455 4.33216C18.574 3.85445 17.9351 3.58526 17.2684 3.58341ZM5.60559 2.09865C5.60582 1.87543 5.69345 1.66142 5.84922 1.50358C6.005 1.34574 6.2162 1.25697 6.4365 1.25673H13.8046C14.0249 1.25697 14.2361 1.34574 14.3919 1.50358C14.5477 1.66142 14.6353 1.87543 14.6355 2.09865V3.58341H5.60559V2.09865Z",
    fill: "#F07F3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffres);
export default __webpack_public_path__ + "static/media/offres.3ed63da803cedd2b6f21b43af5e5c518.svg";
export { ForwardRef as ReactComponent };